import { Config } from "./configType";

export const config: Config = {
  mLogo:
    "https://litb-cgis.rightinthebox.com/images/dfp/fs-images/2022/a141f062cd77d869855d4b1d092d4c8f.jpg",
  pcLogo:
    "https://litb-cgis.rightinthebox.com/imagegy/202101/6f7d42a2d6604946a8118c964eecf487pclogo.png",
  productPartyBg:
    "https://litb-cgis.rightinthebox.com/imagegy/202101/cf083ef8d2294ef6ac50fc6576ac32b6productpartybg.png",
  productLongBg:
    "https://litb-cgis.rightinthebox.com/imagegy/202101/0dec4876788744f09f1042e4afb6af47productlongbg.png",
  bannerBg:
    "https://litb-cgis.rightinthebox.com/imagegy/202101/c6889b0a7d8e4146acdff6f600e0c7b9bannerbg.png",
  PcHeaderConfig: {
    pcAccount:
      "https://litb-cgis.rightinthebox.com/imagegy/202101/cc896cc844374efabeacba976e387df0pcaccount.png",
    pcAccountActive:
      "https://litb-cgis.rightinthebox.com/imagegy/202101/ce523a9a210a4904948bc397ce3a38b7pcaccountactive.png",
    pcFavorites:
      "https://litb-cgis.rightinthebox.com/imagegy/202101/becfe931655e47e9b4191e6e9fa628c9pcfavorites.png",
    pcFavoritesActive:
      "https://litb-cgis.rightinthebox.com/imagegy/202101/f01da46013b04925995706ec2b385d4cpcfavoritesactive.png",
    pcCart:
      "https://litb-cgis.rightinthebox.com/imagegy/202101/e98d8d00b0f8489cb7e4afb8b9f844efpccart.png",
    pcCartActive:
      "https://litb-cgis.rightinthebox.com/imagegy/202101/98a67a2ce31e49e1ab1d675cda6e4967pccartactive.png",
    pcCartEmpty:
      "https://lijc.rightinthebox.com/resource_bbc06d47cd7398fab74da6b7a66355b35081779a_ouku//dev_v2/base-images/header_empty_cart/cart_empty_ouku.png",
  },
  bannerBtnPlaceholder:
    "https://t.rightinthebox.com/tights/litb/c2nmc9jdwhk0_Fu0Vt0_sgFdXM99EPIjHFR0EaHFA.png",
  pcErrorImg:
    "https://t.rightinthebox.com/tights/litb/ws3an7384000_pc_error.png",
};
